import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SearchIcon, MessageSquareIcon } from 'lucide-react';
import { SearchMode } from '../types/company';
import { KeywordSearch } from './KeywordSearch';
import { TextSearch } from './TextSearch';
type SearchPanelProps = {
  mode: SearchMode;
  onModeChange: (mode: SearchMode) => void;
  keywords: string[];
  onKeywordsChange: (keywords: string[]) => void;
  onKeywordSearch: () => void;
  onTextSearch: (query: string) => void;
};
export function SearchPanel({
  mode,
  onModeChange,
  keywords,
  onKeywordsChange,
  onKeywordSearch,
  onTextSearch
}: SearchPanelProps) {
  return <div className="space-y-6" data-id="element-325">
      {/* Mode Toggle */}
      <div className="flex justify-center" data-id="element-326">
        <div className="inline-flex bg-slate-800/50 border border-slate-700 rounded-full p-1" data-id="element-327">
          <button onClick={() => onModeChange('keyword')} className={`relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${mode === 'keyword' ? 'text-slate-900' : 'text-slate-400 hover:text-white'}`} data-id="element-328">
            {mode === 'keyword' && <motion.div layoutId="activeTab" className="absolute inset-0 bg-amber-500 rounded-full" transition={{
            type: 'spring',
            bounce: 0.2,
            duration: 0.6
          }} data-id="element-329" />}
            <SearchIcon className="w-4 h-4 relative z-10" data-id="element-330" />
            <span className="relative z-10" data-id="element-331">Keyword Search</span>
          </button>
          <button onClick={() => onModeChange('text')} className={`relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${mode === 'text' ? 'text-slate-900' : 'text-slate-400 hover:text-white'}`} data-id="element-332">
            {mode === 'text' && <motion.div layoutId="activeTab" className="absolute inset-0 bg-amber-500 rounded-full" transition={{
            type: 'spring',
            bounce: 0.2,
            duration: 0.6
          }} data-id="element-333" />}
            <MessageSquareIcon className="w-4 h-4 relative z-10" data-id="element-334" />
            <span className="relative z-10" data-id="element-335">Text Search</span>
          </button>
        </div>
      </div>

      {/* Search Content */}
      <AnimatePresence mode="wait" data-id="element-336">
        <motion.div key={mode} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} data-id="element-337">
          {mode === 'keyword' ? <KeywordSearch keywords={keywords} onKeywordsChange={onKeywordsChange} onSearch={onKeywordSearch} data-id="element-338" /> : <TextSearch onSearch={onTextSearch} data-id="element-339" />}
        </motion.div>
      </AnimatePresence>
    </div>;
}